import { axiosInstance } from 'utils/http';
import { flow } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from 'react-query';


export const useSetNodeTags = (flowID, nodeID) => {
  const dispatch = useDispatch();
  const orgId = useSelector(state => state.session.user.primaryOrganization.organization.ID);

  const {
    isLoading,
    isSuccess,
    isError,
    data,
    mutate,
  } = useMutation(
    `set-node-tags-${orgId}-${flowID}-${nodeID}`,
    ({ tags, cleanRoomID }) => axiosInstance.put(flow(orgId)
      .setNodeTags(flowID, nodeID), { tags, cleanRoomID }),
    {
      onSuccess: () => {
        dispatch(showAlert({
          message: 'Node tags have been updated.',
          type: 'success',
        }));
      },
      onError: (error) => dispatch(showAlert({
        message: error.response?.data?.message || 'Failed to update node tags.',
        type: 'error',
      })),
    },
  );

  return {
    isLoading,
    isError,
    isSuccess,
    data,
    mutate,
  };
};
